import "./EmbedOnWebsite.css";

const EmbedOnWebsite = () => {
  return (
    <div className="embed-docs-container">
      <h1 className="embed-docs-title">Embedding Chatbot on a Website</h1>

      <p className="embed-docs-intro">
        You can integrate your chatbot into your website using multiple methods. 
        Before proceeding, ensure you have already created and configured your 
        chatbot in the Xenachat dashboard.
      </p>

      <div className="embed-docs-section">
        <h2 className="embed-docs-heading">Step 1: Navigate to Integrations</h2>
        <p className="embed-docs-description">
          On the left sidebar of the dashboard, click on <strong>Integrations</strong>. 
          Here you can view all available integration options for your chatbot.
        </p>
      </div>

      <div className="embed-docs-section">
        <h2 className="embed-docs-heading">Step 2: Choose the Integration Method</h2>
        <ul className="embed-docs-list">
          <li>
            For <strong>WhatsApp and Telegram Integration:</strong> Click on the integrations 
            to obtain the necessary credentials.
          </li>
          <li>
            For <strong>JavaScript Snippet, Iframe, or REST API Integration:</strong> Click 
            on the <strong>Connect</strong> button on the left sidebar to access the connection 
            settings and integration code.
          </li>
        </ul>
      </div>

      <div className="embed-docs-section">
        <h2 className="embed-docs-heading">Step 3: Proceed with Integration</h2>
        <p className="embed-docs-description">
          Once you have selected your preferred integration method, follow the 
          respective instructions in the subsequent sections to embed your chatbot 
          seamlessly into your website or application.
        </p>
      </div>
    </div>
  );
};

export default EmbedOnWebsite;
